import React from 'react'
import styles from './styles.module.scss'

export const TierCard = ({ content, index, backgroundColor }) => {
  return (
    <div className={styles.tierCard}>
      <article
        className={`${styles.tierCard__card} ${styles[`color${index}`]}`}
        style={{ backgroundColor: backgroundColor }}
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </div>
  )
}
